<template>
  <BasePopover
    ref="popover"
    class="dropdown-menu__trigger"
    :class="{
      'dropdown-menu__trigger_disabled': disabled
    }"
    placement="bottom-start"
    :fix-width="fixWidth"
    :popper-class="popperClass"
    @toggle="toggleMenu"
  >
    <template slot="reference">
      <div class="dropdown-menu__trigger">
        <span v-if="dropdownText">
          {{ dropdownText }}
        </span>
        <MIcon
          v-if="icon"
          class="dropdown-menu__icon"
          :icon="icon"
        />
        <MIcon
          class="dropdown-menu__icon dropdown-menu__icon-arrow"
          :class="{ 'dropdown-menu__icon-arrow_active': active }"
          :icon="bulletArrow"
        />
      </div>
    </template>
    <template slot="popper">
      <slot />
    </template>
  </BasePopover>
</template>

<script>
  import bulletArrow from 'assets/icons/bullet-arrow.svg';
  import MIcon from 'components/Design/MIcon';
  import {BasePopover} from 'index';

  export default {
    name: 'DropdownMenu',
    components: {MIcon, BasePopover},
    props: {
      icon: {
        type: Object,
        default: null
      },
      fixWidth: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      dropdownText: {
        type: String,
        default: null
      },
      popperClass: {
        type: [String, Array, Object],
        default: ''
      }
    },
    data () {
      return {
        bulletArrow,
        active: false
      };
    },
    methods: {
      toggleMenu (state) {
        if (this.disabled) {
          this.closeDropdown();
          return;
        }
        this.active = state;
      },
      closeDropdown () {
        this.$refs.popover.closeDropdown();
      }
    }
  };
</script>

<style>
  .dropdown-menu__trigger {
    cursor: pointer;

    display: inline-flex;

    align-items: center;

    height: 18px;
  }

  .dropdown-menu__icon {
    color: var(--action-color);

    width: 18px;
    height: 18px;
  }

  .dropdown-menu__icon-arrow {
    width: 14px;
    height: 14px;

    transform: rotate(90deg);
  }

  .dropdown-menu__icon-arrow_active {
    transform: rotate(270deg);
  }

  .dropdown-menu__trigger_disabled .dropdown-menu__icon {
    color: var(--action-disabled-color);
    cursor: not-allowed;
  }

  .dropdown-menu__trigger:hover .dropdown-menu__icon {
    color: var(--action-hover-color);
  }

  .dropdown-menu__trigger_disabled:hover .dropdown-menu__icon {
    color: var(--action-disabled-color);
  }

</style>
